<template>
  <Callout.Root variant="warning">
    Some content couldn't be converted to Fancy mode.
    <a
      href="https://docs.buttondown.com/editor-modes#switching-between-modes"
      class="font-medium text-muted-foreground underline transition hover:text-foreground"
      >Learn more</a
    >

    <template #actions>
      <Callout.Action @click="emit('switch')">
        Switch to Markdown
      </Callout.Action>
      <Callout.Action @click="emit('close')"> This looks fine </Callout.Action>
    </template>
  </Callout.Root>
</template>

<script setup lang="ts">
import Callout from "@/design_system/Callout";

const emit = defineEmits<{
  switch: [];
  close: [];
}>();
</script>
